import Button from '@app/sharedComponents/Button/Button';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import { ThemedText, ThemedView } from '@app/theme';
import { trackEvent } from '@app/utils';
import React, { useEffect } from 'react';

type InterestRateLearnMoreModalProps = {
  visible: boolean;
  onClose: () => void;
  routeName: string;
};

const InterestRateLearnMoreModal = ({
  visible,
  onClose,
}: InterestRateLearnMoreModalProps) => {
  useEffect(() => {
    if (visible) {
      trackEvent('INFOINTERESTRATECHANGE_BOTTOMSHEET_VIEWED');
    }
  }, [visible]);

  const handleGotIt = () => {
    trackEvent('INFOINTERESTRATECHANGE_GOTIT_CLICKED');
    onClose();
  };

  return (
    <BottomSheetContainer
      isVisible={visible}
      close={onClose}
      onClose={onClose}
      showCloseIcon
      closeOnBackdropPress
      borderTopRightRadius={16}
      borderTopLeftRadius={16}
      containerStyle={{ borderTopRightRadius: 16, borderTopLeftRadius: 16 }}
    >
      <ThemedView px="lg" pt="2xl" pb="lg">
        <ThemedText variant="h5s" color="text-primary" mb="lg" pr="3xl">
          Why does your interest rate change?
        </ThemedText>

        <ThemedText variant="b3r" color="text-primary" mb="2xl">
          The lender calculates interest rates based on multiple factors,
          including the loan amount. Changing the amount may result in a
          different rate.
        </ThemedText>

        <Button
          label="Got it"
          handlePress={handleGotIt}
          type="SOLID"
          size="MD"
          bg="bg-action-primary"
          textColor="text-on-action-primary"
        />
      </ThemedView>
    </BottomSheetContainer>
  );
};

export default InterestRateLearnMoreModal;
